import React, { useId, useState } from "react";
import { ChevronDown } from "lucide-react";

const CollapsibleCard = ({
  icon,
  title,
  subtitle,
  defaultOpen = false,
  children,
  id,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const generatedId = useId();
  const panelId = `${id ?? generatedId}-panel`;

  return (
    <section className="pf-card" id={id}>
      <header className="pf-card__head">
        {icon ? <span className="pf-card__icon">{icon}</span> : null}
        <div>
          <h3 className="pf-card__title">{title}</h3>
          {subtitle ? <div className="pf-card__subtitle">{subtitle}</div> : null}
        </div>
        <button
          type="button"
          className="pf-card__toggle"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls={panelId}
        >
          {open ? "Hide" : "Show"}
          <ChevronDown
            size={14}
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 150ms ease",
            }}
          />
        </button>
      </header>
      {open ? (
        <div className="pf-card__body" id={panelId}>
          {children}
        </div>
      ) : null}
    </section>
  );
};

export default CollapsibleCard;
